import { onBeforeUnmount } from 'vue';
import { useBetBuilderHub } from '@/composable/useBetBuilderHub';
import type { IBetBuilderRecommendation } from '@/interface/betBuilder';

export async function useBetBuilderPreBuiltConnection(
    combinationKey: string,
    onDataUpdated: (payload: IBetBuilderRecommendation) => void,
    onDeleted: () => void,
) {
    const { subscribe: _subscribe, unsubscribe: _unsubscribe } = useBetBuilderHub();

    const callbacks = {
        onUpdate: onDataUpdated,
        onDelete: onDeleted,
    };

    const pendingSubscribe = _subscribe(combinationKey, callbacks);

    onBeforeUnmount(async () => {
        await pendingSubscribe;
        await _unsubscribe(combinationKey, callbacks);
    });

    await pendingSubscribe;
}
